export default function filename(name, extension, info = []) {
  const prefix = info.length ? `${info.join('_')}_` : '';
  const fullName = `${prefix}${name}`
    .replace(/\s+/g, '-')
    .replace(/,/g, '')
    .replace(/ /g, '')
    .replace(/\./g, '')
    .replace(/\+/g, '')
    .replace(/%20/g, '')
    .replace(/\(/g, '')
    .replace(/\)/g, '')
    .replace(/;/g, '')
    .replace(/:/g, '')
    .replace(/\//g, '-');

  return `${fullName}.${extension}`;
}



// WEBPACK FOOTER //
// ./js/utils/filename.js